import React from 'react';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import './FolderViewHeader.component.scss';

const FolderViewHeader = () => {
  return (
    <div className='folder-view-header'>
      <div className='folder-view-header__item'></div>
      <div className='folder-view-header__item'></div>
      <div className='folder-view-header__item bold'>Name</div>
      <div className='folder-view-header__item'>Copied to</div>
      <div className='folder-view-header__item'>Contains</div>
      <div className='folder-view-header__item'>Date modified</div>
      <div className='folder-view-header__item'>
        <MoreHorizOutlinedIcon style={{ fontSize: '24px', color: '#7D7A9A' }} />
      </div>
    </div>
  )
};

export default FolderViewHeader;
